import { Badge } from "@/components/ui"
import { toast } from "sonner";

export const handlePremiumFeatureClick = (message?:string) => {
    toast("Premium Feature", {
      description: message || "Upgrade to our Professional plan to access this feature.",
    });
};

export const PremiumFeature = ({className, style}:{className?:string, style?:any}) => {
    return (
        <div className={className || `absolute -top-4 -right-4 z-10`} style={style ? style : {}}>
          <Badge className="font-semibold border-0 shadow-lg transform transition-all duration-300 relative overflow-hidden group bg-gradient-to-r from-amber-400 via-orange-500 to-red-500 ">
            Upgrade
          </Badge>
        </div>
    )
}